/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_TitleInputs */

const es_settings_dirs_title = /** @type {(inputs: Settings_Dirs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpetas externas`)
};

const en_settings_dirs_title = /** @type {(inputs: Settings_Dirs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External Directories`)
};

/**
* | output |
* | --- |
* | "External Directories" |
*
* @param {Settings_Dirs_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_title = /** @type {((inputs?: Settings_Dirs_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_title(inputs)
	return en_settings_dirs_title(inputs)
});
export { settings_dirs_title as "settings.dirs.title" }